import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { RestyledReverseButton } from '../styles';

/**
 * @deprecated This is deprecated in horizon. Please use SecondaryButtonLink's outlined variant.
 */
var ReverseButtonLink = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      dataTest = _ref['data-test'],
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text/html' : _ref$type,
      buttonLinkProps = _objectWithoutProperties(_ref, ["children", "data-test", "type"]);

  return /*#__PURE__*/React.createElement(RestyledReverseButton, _extends({
    "data-test": dataTest ? dataTest : undefined,
    forwardedAs: "a",
    type: type,
    ref: ref
  }, buttonLinkProps), children);
});
ReverseButtonLink.displayName = 'ReverseButtonLink';
export default ReverseButtonLink;